import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../shared/user.service';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Output() change = new EventEmitter();
  menuList: any[] = [];
  selectedItem: string | null = null;
  userRole: string = '';
  userName: string = '';
  pageList: any[] = [];
  isApplicant: boolean = false;
  isEmployee: boolean = false;
  @ViewChild('panel', { read: ElementRef }) public panel: ElementRef | undefined;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute) {
   
  }

  ngOnInit():void  {
    // this.menuList = localStorage.getItem('menuList');
    // this.menuList = JSON.parse(this.menuList);
    // let selectedMenuId = localStorage.getItem('selectedMenu');
    // if (selectedMenuId != null && selectedMenuId != '' && typeof (selectedMenuId) != undefined)
    //   this.selectedItem = selectedMenuId;
    // else {
    //   if (this.menuList.length != 0)
    //     this.selectedItem = this.menuList[0].KM_MenuId;
    // }
    const storedMenuList = localStorage.getItem('menuList');
    if (storedMenuList) {
      this.menuList = JSON.parse(storedMenuList);
    }

    this.selectedItem = localStorage.getItem('selectedMenu') || (this.menuList.length > 0 ? this.menuList[0].KM_MenuId : null);
//debugger;
    for (let menu of this.menuList) {
      if (menu.KHB_MenuName === 'Applicant') {
        this.pageList = menu.BSHB_PagesList;
        this.isApplicant = true;
      } else if (menu.KHB_MenuName === 'Administration') {
        this.pageList = menu.BSHB_PagesList;
        this.isEmployee = true;
      }
    }

  }
 
  listClick(event: Event, newValue: string, KM_Id: string): void {
    localStorage.setItem('selectedMenu', newValue);
    this.selectedItem = newValue;
  }

  toggleSidebar(): void {
    document.body.classList.toggle('open-sidebar');
  }

  NavigateUrl(URL: string): void {
    if (URL) {
      this.router.navigate([URL]);
    }
  }

  
  



}




// WEBPACK FOOTER //
// ./src/app/common/sidebar/sidebar.component.ts